module.exports = __webpack_public_path__ + "img/file_ppt.463f3839.svg";